import { createHash } from "node:crypto";
export function stableStringify(value) {
    return JSON.stringify(sortForHash(value));
}
export function deterministicHash(value) {
    return createHash("sha256").update(stableStringify(value)).digest("hex");
}
function sortForHash(value) {
    if (Array.isArray(value)) {
        return value.map((entry) => sortForHash(entry));
    }
    if (value && typeof value === "object") {
        const entries = Object.entries(value)
            .filter(([, entryValue]) => entryValue !== undefined)
            .sort(([left], [right]) => left.localeCompare(right));
        return Object.fromEntries(entries.map(([key, entryValue]) => [key, sortForHash(entryValue)]));
    }
    return value;
}
//# sourceMappingURL=hash.js.map